import { useSelector } from "react-redux"
import { alerts as alertKeys } from 'keys'
import { adminAssessmentsRQ } from "store/hooks"
import { useMutation } from "@tanstack/react-query"
import { backToMarkingWordsFetch } from "store/middlewares/markingWords.crud"
import { useEffect } from "react"

const useBackToConfirmation = () => {
    const { alerts } = useSelector(state => state.general)

    //TODO
    const { isFetching: adminAssessmentsLoading } = adminAssessmentsRQ.useGetAdminAssessments({ enabled: false })
    const { mutateAsync: backToMarkingWordsRQ, isLoading: backToMarkingWordsLoading } = useMutation({ mutationFn: backToMarkingWordsFetch, mutationKey: "backToMarkingWords" })

    const backToConfirmationFields = {
        title: alerts[alertKeys.backTo].props?.title,
        content: alerts[alertKeys.backTo].props?.content,
        btns: [{
            label: "אישור",
            action: async () => {
                await alerts[alertKeys.backTo].props?.onConfirm()
                alerts[alertKeys.backTo].props?.onClose()
            },
            variant: "text",
            loading: adminAssessmentsLoading
            //  || alerts[alertKeys.backTo].props.loading || backToMarkingWordsLoading
        },
        {
            label: "ביטול",
            action: alerts[alertKeys.backTo].props?.onClose,
            variant: "text",
            disabled: adminAssessmentsLoading
        }]
    }

    return backToConfirmationFields
}

export default useBackToConfirmation